import { Box, Collapse, Alert, IconButton, AlertTitle } from "@mui/material";
import React from "react";
import Close from '@mui/icons-material/Close';


const CallAlertBar = ({ parentRollMsgOpen, setParentRollMsgOpen, parentRollSeverityvalue, setParentRollSeverityvalue, parentRollAlertTitleValue, setParentRollAlertTitleValue, parentRollMessageValue, setParentRollMessageValue }) => {
    return (
        <Box sx={{ width: '100%' }}>
            {/* ,padding:"5px" */}
            <Collapse in={parentRollMsgOpen}>
                <Alert severity={parentRollSeverityvalue}
                    action={
                        <IconButton
                            onClick={() => {
                                setParentRollMsgOpen(false);
                            }}
                        >
                            <Close fontSize="inherit" />
                        </IconButton>                    }
                    
                >
                    <AlertTitle>{parentRollAlertTitleValue}</AlertTitle>
                    {/* {parentRollMessageValue} */}
                    {/* Render the validation messages as a list */}
                    <ul>
                        {parentRollMessageValue.split('\n').map((msg, index) => (
                            // Use index as key if no unique identifier is available
                            <li key={index}>{msg}</li>
                        ))}
                    </ul>
                </Alert>
            </Collapse>
        </Box>

    );

};
export default CallAlertBar;




// import React, { useEffect } from "react";
// import {
//   Box,
//   Collapse,
//   Alert,
//   IconButton,
//   AlertTitle,
//   Typography,
//   Paper,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";

// const CallAlertBar = ({
//   parentRollMsgOpen,
//   setParentRollMsgOpen,
//   parentRollSeverityvalue,
//   parentRollAlertTitleValue,
//   parentRollMessageValue,
// }) => {
//   // Auto-hide after 20 seconds
//   useEffect(() => {
//     if (parentRollMsgOpen) {
//       const timer = setTimeout(() => {
//         setParentRollMsgOpen(false);
//       }, 2000); // 20 seconds

//       return () => clearTimeout(timer); // cleanup
//     }
//   }, [parentRollMsgOpen, setParentRollMsgOpen]);

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         display: "flex",
//         justifyContent: "center",
//         mt: 2,
//       }}
//     >
//       <Collapse in={parentRollMsgOpen} timeout={400}>
//         <Paper
//           elevation={4}
//           sx={{
//             borderRadius: 3,
//             overflow: "hidden",
//           }}
//         >
//           <Alert
//             severity={parentRollSeverityvalue}
//             variant="filled"
//             action={
//               <IconButton
//                 onClick={() => setParentRollMsgOpen(false)}
//                 size="small"
//                 sx={{ color: "white" }}
//               >
//                 <CloseIcon fontSize="inherit" />
//               </IconButton>
//             }
//             sx={{
//               borderRadius: 3,
//               minWidth: 350,
//               p: 2,
//               "& .MuiAlert-icon": {
//                 fontSize: 28,
//               },
//             }}
//           >
//             <AlertTitle
//               sx={{
//                 fontWeight: 700,
//                 fontSize: "1.1rem",
//                 mb: 1,
//               }}
//             >
//               {parentRollAlertTitleValue}
//             </AlertTitle>

//             {/* Render validation messages as list */}
//             {parentRollMessageValue ? (
//               <Box component="ul" sx={{ pl: 3, m: 0 }}>
//                 {parentRollMessageValue.split("\n").map((msg, index) => (
//                   <Typography
//                     key={index}
//                     component="li"
//                     variant="body2"
//                     sx={{ lineHeight: 1.6 }}
//                   >
//                     {msg}
//                   </Typography>
//                 ))}
//               </Box>
//             ) : null}
//           </Alert>
//         </Paper>
//       </Collapse>
//     </Box>
//   );
// };

// export default CallAlertBar;



